import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { fillVariants } from "../../../styles";
import { classNames } from "../../../utils";
export const SomniaLogoCircle = t0 => {
  const $ = _c(29);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    const {
      className: t2,
      size: t3,
      square,
      ...t4
    } = t0;
    className = t2;
    t1 = t3;
    rest = t4;
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const uid = useId();
  const g0 = `paint0_linear_${uid}`;
  const g1 = `paint1_linear_${uid}`;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `url(#${g0})`;
  let t4;
  if ($[6] !== t3) {
    t4 = <path d="M12.0224 3.58728C12.0281 3.35631 12.3279 3.27146 12.4561 3.46284C14.0002 5.76973 16.6294 7.28848 19.6139 7.28848C20.7329 7.28848 21.8019 7.07448 22.7823 6.68607C20.8309 2.74069 16.7745 0.0227692 12.0809 0.000143355C5.4924 -0.0319099 0.0747474 5.31532 0.0228993 11.9041C0.0125297 13.2249 0.216151 14.4976 0.600769 15.6883C3.43639 15.4536 6.2079 14.2525 8.37704 12.0823C10.73 9.72924 11.9451 6.67004 12.0224 3.58728Z" fill={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `url(#${g1})`;
  let t6;
  if ($[8] !== t5) {
    t6 = <path d="M11.9651 23.9999C18.5526 24.031 23.9694 18.6866 24.0222 12.0987C24.0325 10.7779 23.8289 9.50616 23.4452 8.31548C20.6087 8.55022 17.8381 9.75127 15.668 11.9215C13.315 14.2745 12.1008 17.3337 12.0235 20.4165C12.0179 20.6475 11.7181 20.7323 11.5899 20.5409C10.0458 18.2341 7.41658 16.7153 4.43201 16.7153C3.31398 16.7153 2.24496 16.9284 1.26456 17.3168C3.21688 21.2603 7.27235 23.9772 11.9651 23.9999Z" fill={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <stop stopColor="#4B1BF9" />;
    t8 = <stop offset="1" stopColor="#3ECCEE" />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== g0) {
    t9 = <linearGradient gradientUnits="userSpaceOnUse" id={g0} x1="22.7823" x2="9.57872" y1="-8.42108e-07" y2="18.4678">{t7}{t8}</linearGradient>;
    $[12] = g0;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <stop stopColor="#F20A49" />;
    t11 = <stop offset="0.52" stopColor="#C119E7" />;
    t12 = <stop offset="1" stopColor="#4675F3" />;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
  }
  let t13;
  if ($[17] !== g1) {
    t13 = <linearGradient gradientUnits="userSpaceOnUse" id={g1} x1="24.0225" x2="10.8228" y1="8.31547" y2="26.7809">{t10}{t11}{t12}</linearGradient>;
    $[17] = g1;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t9) {
    t14 = <defs>{t9}{t13}</defs>;
    $[19] = t13;
    $[20] = t9;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== className || $[23] !== rest || $[24] !== t14 || $[25] !== t2 || $[26] !== t4 || $[27] !== t6) {
    t15 = <svg className={className} fill="none" style={t2} viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t4}{t6}{t14}</svg>;
    $[22] = className;
    $[23] = rest;
    $[24] = t14;
    $[25] = t2;
    $[26] = t4;
    $[27] = t6;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};
export const SomniaLogoCircleMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== className || $[7] !== fill) {
    t4 = classNames(className, fillVariants({
      fill
    }));
    $[6] = className;
    $[7] = fill;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== size) {
    t5 = {
      width: size,
      height: size
    };
    $[9] = size;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M12.0224 3.58728C12.0281 3.35631 12.3279 3.27146 12.4561 3.46284C14.0002 5.76973 16.6294 7.28848 19.6139 7.28848C20.7329 7.28848 21.8019 7.07448 22.7823 6.68607C20.8309 2.74069 16.7745 0.0227692 12.0809 0.000143355C5.4924 -0.0319099 0.0747474 5.31532 0.0228993 11.9041C0.0125297 13.2249 0.216151 14.4976 0.600769 15.6883C3.43639 15.4536 6.2079 14.2525 8.37704 12.0823C10.73 9.72924 11.9451 6.67004 12.0224 3.58728Z" fillRule="evenodd" />;
    t7 = <path d="M11.9651 23.9999C18.5526 24.031 23.9694 18.6866 24.0222 12.0987C24.0325 10.7779 23.8289 9.50616 23.4452 8.31548C20.6087 8.55022 17.8381 9.75127 15.668 11.9215C13.315 14.2745 12.1008 17.3337 12.0235 20.4165C12.0179 20.6475 11.7181 20.7323 11.5899 20.5409C10.0458 18.2341 7.41658 16.7153 4.43201 16.7153C3.31398 16.7153 2.24496 16.9284 1.26456 17.3168C3.21688 21.2603 7.27235 23.9772 11.9651 23.9999Z" fillRule="evenodd" />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] !== fillAttribute || $[14] !== rest || $[15] !== t4 || $[16] !== t5) {
    t8 = <svg className={t4} fill={fillAttribute} style={t5} version="1.1" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}{t7}</svg>;
    $[13] = fillAttribute;
    $[14] = rest;
    $[15] = t4;
    $[16] = t5;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};